import GoogleConfiguration from './GoogleConfiguration';

export default GoogleConfiguration;
